// extracted by mini-css-extract-plugin
module.exports = {"welcomeText":"style__welcomeText__CGTyB","welcomeBox":"style__welcomeBox__DDhEc"};